import axios from "axios";
import AdvancedQuestionHandler from "./advanced-player-question";
import 'video.js/dist/video-js.css';
import videojs from 'video.js';
import {modalPay} from "../modal-pay/modal-pay";
import NoSleep from 'nosleep.js';
//import 'videojs-contrib-hls';

const CLASS_PREFIX = "advanced-player";
const DATA_PREFIX = "data-advanced-player";

/**
 * Утилита для выборки элементов по data-атрибутам
 */
export function queryDataAttr(attr, container = document) {
    return container.querySelector(`[${DATA_PREFIX}-${attr}]`);
}

export function querysDataAttr(attr, container = document) {
    return container.querySelectorAll(`[${DATA_PREFIX}-${attr}]`);
}

class AdvancedPlayer {
    constructor($container) {
        this.noSleep = new NoSleep();
        this.wakeLock = null;

        this.$container = $container;
        this.classPrefix = CLASS_PREFIX;
        this.dataPrefix = DATA_PREFIX;

        this.exercise = {
            id: null,
            questions: [],
            responded_questions: [],
            total: 0,
            is_demo: false,
            is_completed: false,
            is_restart: false,
        }

        this.answeredPausePoints = new Set();
        this.currentPausePointIndex = 0;
        this.currentPointIndex = 0;
        this.isStarted = false;
        this.isSelected = false;
        this.isWaitingForAnswer = false;

        // Сохраняем привязанный обработчик, чтобы потом корректно удалить его
        this.boundContinueVideo = this.continueVideo.bind(this);

        this.initElements();
        this.initPlayer();
        this.bindEvents();
        this.init();
    }

    // region Инит --

    /**
     * Инициализация Модуля player.js
     */
    initPlayer() {
        const $videoEl = this.$container.querySelector('video');
        this.playerJS = videojs($videoEl, {
            controls: false,
            preload: 'auto',
            playInline: true,
            //fluid: true,
        }, () => {
            console.log('Player initialized');
        });

        this.playerJS.ready(() => {
            console.log('Video.js готов к работе');
        });

        // Перенаправляем слушатели
        this.playerJS.on('loadedmetadata', () => {
            this.$loader.style.display = 'none';
        });
        this.playerJS.on('timeupdate', this.handlePlayerTime.bind(this));
        this.playerJS.on('ended', () => this.handleVideoEnd());
        this.playerJS.on('progress', this.updateBuffer.bind(this));
        this.playerJS.on('play',  () => this.enableWakeLock());
        this.playerJS.on('pause', () => this.disableWakeLock());
    }

    async enableWakeLock() {
        if ('wakeLock' in navigator) {
            try {
                this.wakeLock = await navigator.wakeLock.request('screen');
                return;
            } catch (err) { /* fallback */ }
        }
        this.noSleep.enable();
    }

    async disableWakeLock() {
        if (this.wakeLock) {
            await this.wakeLock.release();
            this.wakeLock = null;
        }
        this.noSleep.disable();
    }

    /**
     * Инициализация ссылок на элементы DOM
     */
    initElements() {
        // Элементы плеера и загрузчика
        //this.playerJS = queryDataAttr("video", this.$container);
        this.$loader = queryDataAttr("loader", this.$container);

        this.$backLink = queryDataAttr("back", this.$container);

        // Элементы таймлайна – ищем внутри контейнера, чтобы не затрагивать другие плееры
        this.$timeline = queryDataAttr("timeline", this.$container);
        this.$timelineProgress = queryDataAttr("timeline-progress", this.$timeline);
        this.$timelineMarkersContainer = queryDataAttr("timeline-markers", this.$timeline);
        this.$timelineBuffer = queryDataAttr("timeline-buffer", this.$timeline);


        // Элементы оверлея с вопросом
        this.$questionOverlay = queryDataAttr("question-overlay", this.$container);

        // Дополнительные элементы вопросов


        // Элементы стартового оверлея
        this.$startOverlay = queryDataAttr("start-overlay", this.$container);

        this.$startLabel = queryDataAttr("start-label", this.$container);
        this.$startSubtitle = queryDataAttr("start-subtitle", this.$container);
        this.$startTitle = queryDataAttr("start-title", this.$container);
        this.$startText = queryDataAttr("start-text", this.$container);

        this.$startBtn = queryDataAttr("start-btn", this.$container);
        this.$startBtnText = queryDataAttr("start-btn-text", this.$container);

        // Элементы управления плеером
        this.$controlOverlay = queryDataAttr("player-control", this.$container);
        this.$controlPause = queryDataAttr("player-control-pause", this.$container);
        this.$controlPlay = queryDataAttr("player-control-play", this.$container);
        this.$controlPlayBtn = queryDataAttr("player-control-play-btn", this.$container);
        this.$controlPlayNext = queryDataAttr("player-control-next", this.$container);
        this.$controlPlayPrev = queryDataAttr("player-control-prev", this.$container);

        this.$controlSpeedUp = queryDataAttr("player-control-speed-up", this.$container);
        this.$controlSpeedUpDigit = queryDataAttr("player-control-speed-up-digit", this.$container);
        this.$controlRewindBack = queryDataAttr("player-control-rewind-back", this.$container);
        this.$controlRewindForward = queryDataAttr("player-control-rewind-forward", this.$container);

        // Шаблон финального экрана (находится в document, если он общий для всех плееров)
        this.$finalContainerTemplate = queryDataAttr("final-template", document);

        this.$questionSelectTemplate = queryDataAttr('question-select-template', this.$container)
        this.$questionSwipeTemplate = queryDataAttr('question-swipe-template', this.$container)
        this.$questionOpenTemplate = queryDataAttr('question-open-template', this.$container)

        this.$difficultyOptionsContainer = queryDataAttr('difficulty-container', this.$container)
        this.$difficultyOptions = querysDataAttr('difficulty-option', this.$container)

    }

    /**
     * Привязка событий к элементам
     */
    bindEvents() {
        console.log('SET loadedmetadata')

        // События стартового экрана
        this.$startBtn.addEventListener("click", this.handleStart.bind(this));

        this.$controlSpeedUp.addEventListener('click', this.handleSpeedUp.bind(this));

        this.$controlRewindBack.addEventListener('click', this.handleRewindBack.bind(this));
        this.$controlRewindForward.addEventListener('click', this.handleRewindForward.bind(this));


        // События управления плеером
        this.$controlPlayBtn.addEventListener("click", this.handlePlay.bind(this));
        this.$controlPause.addEventListener("click", this.handlePause.bind(this));
        this.$controlPlayNext.addEventListener("click", this.handlePlayNext.bind(this));
        this.$controlPlayPrev.addEventListener("click", this.handlePlayPrev.bind(this));

        this.$difficultyOptions.forEach($difficultyOption => {
            $difficultyOption.addEventListener("click", async () => {
                const $currentExerciseId = $difficultyOption.dataset.exercise;
                if ($currentExerciseId) {

                    this.exercise.id = $currentExerciseId
                    await this.initExercise();
                }
            })
        })
    }

    /**
     * Основная инициализация плеера:
     * - отключение стандартных контролов
     * - загрузка данных видео и вопросов
     * - установка времени видео для уже отвеченных вопросов (если есть)
     * - инициализация таймлайна
     */
    async init() {
        this.exercise.id = window.currentExerciseId;
        this.exercise.videoId = window.currentVideoId;
        this.exercise.is_restart = window.currentExerciseIsRestart
        console.log('isRestart', this.exercise.is_restart)

        this.$controlPlayBtn.style.display = "flex";
        this.$controlPlay.style.display = "none";
        this.$loader.style.display = "none";

        if (this.exercise.id) {
            await this.initExercise();
        }

    }


    async initExercise() {
        this.$difficultyOptionsContainer.style.display = 'none';
        this.$loader.style.display = "flex";
        this.$backLink.href = `/exercise/${this.exercise.videoId}`

        await this.getExerciseDetails();
        await this.setInitialVideoTime();
        await this.initTimeline();
        await this.setExerciseIntro();
        await this.setGroupTaskData();
        this.showlogs();


        console.log('a')

        if (this.exercise.is_completed && this.exercise.is_restart == null) {
            console.log('COMPLETED')
            this.handleVideoEnd()
            return
        }
        this.$loader.style.display = "none";
        this.$startBtn.style.display = 'flex';
    }


    //endregion

    // region Обработка таймлайна --
    /**
     * Установка начального времени воспроизведения видео, если есть предыдущие ответы
     */
    async setInitialVideoTime() {
        const {questions, responded_questions} = this.exercise;
        if (responded_questions.length <= 0) {
            this.currentPointIndex = 0;
            this.currentPausePointIndex = 0;
            return
        }

        this.$startBtnText.innerText = "Продолжить просмотр";

        // Собираем индексы отвеченных вопросов
        const answeredIndexes = responded_questions
            .map(rq => questions.findIndex(q => q._uid === rq._uid))
            .filter(i => i !== -1)
            .sort((a, b) => a - b);

        // Последний отвеченный индекс
        const lastIdx = answeredIndexes[answeredIndexes.length - 1];

        // Ищем следующий неотвеченный сегмент после последнего отвеченного
        let nextIdx = lastIdx + 1;
        while (answeredIndexes.includes(nextIdx) && nextIdx < questions.length) {
            nextIdx++;
        }

        // Устанавливаем, где начать
        this.currentPausePointIndex = nextIdx < questions.length ? nextIdx : lastIdx;
        this.currentPointIndex = lastIdx;

        // Устанавливаем время видео
        this.playerJS.currentTime(questions[lastIdx].pause_time);

        // Сохраняем набор отвеченных для дальнейшего использования
        this.answeredPausePoints = new Set(answeredIndexes);
    }

    /**
     * Инициализация таймлайна: расстановка маркеров согласно pause_time вопросов
     */
    async initTimeline() {
        const duration = this.playerJS.duration();
        if (!duration || isNaN(duration) || this.exercise.questions.length === 0) {
            //this.playerJS.addEventListener("loadedmetadata", this.initTimeline.bind(this), {once: true});
            this.playerJS.on('loadedmetadata', this.initTimeline.bind(this))
            return;
        }
        this.$timelineMarkersContainer.innerHTML = "";
        this.exercise.questions.forEach((question, index) => {
            const marker = document.createElement("div");
            marker.classList.add(`${this.classPrefix}__timeline-marker`);
            const posPercent = (question.pause_time / duration) * 100;
            marker.style.left = `${posPercent}%`;
            marker.setAttribute("data-question-index", index);
            this.$timelineMarkersContainer.appendChild(marker);
        });
    }

    /**
     * Обновление визуального прогресса таймлайна
     */
    updateTimelineProgress() {
        const duration = this.playerJS.duration();
        if (!duration) return;

        const t = this.playerJS.currentTime();
        const progressPercent = (t / duration) * 100;
        this.$timelineProgress.style.width = `${progressPercent}%`;
    }

    updateBuffer() {
        const duration = this.playerJS.duration();
        if (!duration) return;

        // получаем последний загруженный фрагмент
        const buffered = this.playerJS.buffered(); // объект TimeRanges
        let end = 0;
        // возьмём самый правый конец
        for (let i = 0; i < buffered.length; i++) {
            if (buffered.end(i) > end) {
                end = buffered.end(i);
            }
        }

        // вычисляем процент
        const bufferPercent = (end / duration) * 100;
        this.$timelineBuffer.style.width = `${bufferPercent}%`;
    }

    /**
     * Обработка события timeupdate плеера: проверка достижения точки с вопросом
     */
    handlePlayerTime() {
        console.log('currentPointIndex: ' + this.currentPointIndex + ' | currentPausePointIndex: ' + this.currentPausePointIndex);

        this.updateTimelineProgress();
        if (this.isWaitingForAnswer
            || this.answeredPausePoints.has(this.currentPausePointIndex)
        ) return;

        if (!this.isStarted) {
            return;
        }

        const currentTime = this.playerJS.currentTime();
        if (this.exercise.questions.length > 0) {
            const segmentIndex = this.findSegmentIndex(currentTime, this.exercise.questions);
            this.currentPointIndex = segmentIndex;
        } else {
            this.currentPointIndex = 0;
        }

        //console.log('currentPointIndex: ' + this.currentPointIndex + ' | currentPausePointIndex: ' + this.currentPausePointIndex);

        if (this.currentPointIndex >= this.currentPausePointIndex) {
            const pauseTime = this.exercise.questions[this.currentPausePointIndex]?.pause_time;
            if (pauseTime !== undefined && currentTime >= pauseTime) {
                this.playerJS.pause();
                this.showQuestion(this.exercise.questions[this.currentPausePointIndex], this.currentPausePointIndex);
            }
        }

        this.checkNavButtonEnable();
    }

    //endregion

    //region Обработка задания --

    setExerciseIntro() {

        this.$startLabel.innerText = this.exercise.intro.intro_about ? this.exercise.intro.intro_about : this.exercise.video.intro_about;
        this.$startSubtitle.innerText = this.exercise.intro.intro_subtext ? this.exercise.intro.intro_subtext : this.exercise.video.intro_subtext;
        this.$startTitle.innerText = this.exercise.intro.intro_title ? this.exercise.intro.intro_title : this.exercise.video.intro_title;
        this.$startText.innerText = this.exercise.intro.intro_description ? this.exercise.intro.intro_description : this.exercise.video.intro_description;
    }

    buildQuestion(question, showIndex) {
        // Обнуляем флаги, чтобы QuestionHandler мог корректно отрабатывать повторно
        this.isSelected = false;

        AdvancedQuestionHandler.render(
            question,
            showIndex,
            {
                onAnswer: async (questionUid, answerPayload) => {
                    // 1) Сохраняем асинхронно на сервер
                    await this.saveAnswer(questionUid, answerPayload);

                    // 2) Запоминаем, что этот вопрос уже отвечен
                    this.answeredPausePoints.add(this.currentPausePointIndex);

                    // 3) Находим следующий pausePoint
                    this.updatePausePointIndex();
                },
                onContinue: () => {
                    this.continueVideo();
                },
                onRetry: () => {
                    this.retrySegment();
                },
            },
            {
                container: this.$questionOverlay,
                templates: {
                    select: this.$questionSelectTemplate,
                    swipe: this.$questionSwipeTemplate,
                    open_text: this.$questionOpenTemplate,
                },
                classPrefix: this.classPrefix,
                dataPrefix: this.dataPrefix,
                total: this.exercise.total,
                exerciseId: this.exercise.id,
                videoId: this.exercise.videoId,
                type: this.exercise.type
            }
        );
    }


    updatePausePointIndex() {
        const nextIndex = this.exercise.questions.findIndex(
            (q, i) => i > this.currentPausePointIndex && !this.answeredPausePoints.has(i)
        );
        this.currentPausePointIndex = nextIndex === -1
            ? this.exercise.questions.length
            : nextIndex;
    }

    //endregion

    // region События видео --
    /**
     * Отображение вопроса в момент паузы видео
     */
    showQuestion(question, index) {
        this.isWaitingForAnswer = true;
        const showIndex = index + 1;
        this.currentPointIndex = index;
        this.buildQuestion(question, showIndex);
        this.$questionOverlay.classList.add(`${this.classPrefix}__overlay--active`);
    }

    showModal() {
        this.$startOverlay.style.display = "none";
        this.$questionOverlay.classList.add(`${this.classPrefix}__overlay--active`);
        modalPay(this.$questionOverlay, this.exercise.videoId);
    }

    /**
     * Продолжение воспроизведения видео после ответа на вопрос
     */
    continueVideo() {
        this.isWaitingForAnswer = false;
        this.isSelected = false;
        this.answeredPausePoints.add(this.currentPointIndex);
        this.$questionOverlay.classList.remove(`${this.classPrefix}__overlay--active`);
        const t = this.playerJS.currentTime() + 0.05;
        this.playerJS.currentTime(t);
        this.playerJS.play();
    }

    /**
     * Повтор сегмента видео при неправильном ответе
     */
    retrySegment() {
        this.isWaitingForAnswer = false;
        this.$questionOverlay.classList.remove(`${this.classPrefix}__overlay--active`);
        if (this.currentPausePointIndex > 0) {
            this.playerJS.currentTime(this.exercise.questions[this.currentPausePointIndex - 1].pause_time);
        } else {
            this.playerJS.currentTime(0);
        }
        this.updateTimelineProgress();
        this.playerJS.play();
    }

    /**
     * Обработка окончания видео
     */
    handleVideoEnd() {
        console.log('VIDEO END')


        // Удаляем обработчик с использованием сохранённой ссылки

        if (!this.exercise.is_video_accessible) {
            this.showModal()
        } else {
            window.location.href = `/exercise/${this.exercise.videoId}/task/${this.exercise.id}/result`;
            return;

            const $finalContainerClone = document.importNode(this.$finalContainerTemplate.content, true);
            const $finalTitle = $finalContainerClone.querySelector(`[${this.dataPrefix}-final-title]`);
            const $finalText = $finalContainerClone.querySelector(`[${this.dataPrefix}-final-text]`);
            $finalTitle.innerText = "Вы завершили упражнение";
            $finalText.innerText = "Теперь вы можете перейти к результатам";
            //this.$questionOverlayContainer.appendChild($finalContainerClone);

            this.$startLabel.innerText = "";
            this.$startSubtitle.innerText = "";
            this.$startTitle.innerText = "Вы завершили упражнение";
            this.$startText.innerText = "Теперь вы можете перейти к результатам";

            const $newBtn = this.$startBtn.cloneNode(true);
            $newBtn.textContent = "Посмотреть результаты";
            this.$startBtn.parentNode.replaceChild($newBtn, this.$startBtn);
            $newBtn.addEventListener("click", () => {
                window.location.href = `/exercise/${this.exercise.videoId}/task/${this.exercise.id}/result`;
            });
            $newBtn.style.display = 'flex';
            this.$startOverlay.style.display = "flex";
        }


    }

    //endregion

    // region Управление плеером --

    handleSpeedUp() {
        const currentRate = this.playerJS.playbackRate();

        // Задаем новую скорость (например, увеличиваем на 0.5x до макс. 3x)
        const newRate = currentRate >= 3 ? 1 : currentRate + 0.5;

        // Устанавливаем скорость воспроизведения
        this.playerJS.playbackRate(newRate);

        // (Необязательно) отображаем новую скорость на кнопке
        this.$controlSpeedUpDigit.textContent = `${newRate}x`;
    }

    handleRewindBack() {
        this.playerJS.currentTime(this.playerJS.currentTime() - 5);
    }

    handleRewindForward() {
        this.playerJS.currentTime(this.playerJS.currentTime() + 5);
    }

    handleStart() {

        if (!this.exercise.is_video_accessible) {
            this.showModal();
            return;
        }

        this.playerJS.play();
        this.$startOverlay.style.display = "none";
        this.$controlPlay.style.display = "none";
        this.$controlPause.style.display = "flex";

        this.$controlSpeedUp.classList.add(`${this.classPrefix}__player-control-speed-up--active`);
        setTimeout(() => {
            this.$controlSpeedUp.classList.remove(`${this.classPrefix}__player-control-speed-up--active`);
        }, 5000);

        this.isStarted = true;
        this.showlogs();
    }

    handlePlay() {
        this.playerJS.play();
        this.$controlPlay.style.display = "none";
        this.$controlPause.style.display = "flex";
    }

    handlePause() {
        this.playerJS.pause();
        this.$controlPause.style.display = "none";
        this.$controlPlay.style.display = "flex";
        this.checkNavButtonEnable();
    }

    checkNavButtonEnable() {
        if (this.currentPointIndex >= this.currentPausePointIndex) {
            this.$controlPlayNext.classList.add(`${this.classPrefix}__player-control-btn--inactive`);
        } else {
            this.$controlPlayNext.classList.remove(`${this.classPrefix}__player-control-btn--inactive`);
        }
    }

    /**
     * Переход к следующему сегменту, если следующий вопрос уже отвечен.
     */
    handlePlayNext() {
        if (this.currentPointIndex >= this.currentPausePointIndex) {
            return; // Нельзя переходить вперёд, если есть неотвеченные вопросы
        }
        this.playerJS.currentTime(this.exercise.questions[this.currentPointIndex].pause_time);
        this.updateTimelineProgress();
        this.checkNavButtonEnable();
    }

    /**
     * Переход к предыдущему сегменту, если предыдущий вопрос уже отвечен.
     * Если индекс для перехода меньше 0 или сегмент не отмечен, перемещаемся в начало.
     */
    handlePlayPrev() {
        if (this.currentPointIndex === null || this.currentPointIndex === 0) {
            this.playerJS.currentTime(0);
            return;
        }
        const rePrevIndex = this.currentPointIndex - 2;
        if (rePrevIndex < 0 || !this.answeredPausePoints.has(rePrevIndex)) {
            this.playerJS.currentTime(0);
            return;
        }
        const newTime = this.exercise.questions[rePrevIndex].pause_time;
        this.playerJS.currentTime(newTime);
        this.updateTimelineProgress();
        this.showlogs();
        this.checkNavButtonEnable();
    }

    // endregion

    // region API запросы --
    /**
     * Загрузка данных видео с сервера
     */

    async setGroupTaskData(){
        try {
            let payload = {
                "task_id": this.exercise.id,
                'status': 'in_progress'
            };

            const response = await axios.post(`/api/set-group-task-progress`, payload);
            console.log('setGroupTaskData', response.data);
        } catch (error) {
            console.error("Ошибка загрузки данных видео:", error);
        }
    }
    async getExerciseDetails() {
        try {
            const response = await axios.get(`/api/exercise/${this.exercise.id}`);
            if (response.data) {

                const data = response.data.data
                console.log('DATA', data)
                const isAccessible = data.is_video_accessible;

                this.exercise = {
                    ...this.exercise,
                    video: data.video,
                    type: data.type,
                    intro: data.intro,
                    is_demo: data.video.is_free,
                    is_completed: data.is_completed,

                    is_video_accessible: isAccessible,
                    questions: isAccessible ? data.questions : [],
                    responded_questions: isAccessible ? data.responded_questions : [],
                    total: isAccessible ? data.total : 0,
                };

                if (this.exercise.is_restart) {
                    this.exercise.responded_questions = [];
                }


                // Сброс времени и перезагрузка
                this.playerJS.currentTime(0);
                this.playerJS.load();
            }
        } catch (error) {
            console.error("Ошибка загрузки данных видео:", error);
        }
    }

    /**
     * Сохранение ответа пользователя через API
     */
    saveAnswer(questionUid, answer) {
        return axios.post("/exercise/save", {
            exercise_id: this.exercise.id,
            question_uid: questionUid,
            answer: answer,
        })
            .then((response) => {

            })
            .catch((error) => {
                console.error("Ошибка при сохранении ответа:", error);
            });
    }

    // endregion

    // region Утилиты --
    showlogs() {
        console.log('------------');
        console.log('this.exercise', this.exercise);
        console.log('---');
        console.log('this.answeredPausePoints', this.answeredPausePoints);
        console.log('this.currentPausePointIndex', this.currentPausePointIndex);
        console.log('this.currentPointIndex', this.currentPointIndex);
        console.log('------------');
    }

    /**
     * Находим текущий индекс сегмента
     */
    findSegmentIndex(currentTime, questions) {
        let low = 0, high = questions.length;
        while (low < high) {
            const mid = low + Math.floor((high - low) / 2);
            if (currentTime < questions[mid].pause_time) {
                high = mid;
            } else {
                low = mid + 1;
            }
        }
        return low;
    }

    //endregion
}

// Инициализация плеера, если найден контейнер
const container = document.querySelector(`[${DATA_PREFIX}-container]`);
if (container) {
    new AdvancedPlayer(container);
}

export {AdvancedPlayer};
